import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'add-button',
  templateUrl: './add-button.component.html',
  styleUrls: ['./add-button.component.scss']
})
export class AddButtonComponent implements OnInit {

  @Input() disabled = false;
  @Input() flex = true;
  @Input() vtGreen = false;
  @Output() addClick = new EventEmitter<void>();
  hover = false;

  constructor() {
  }

  ngOnInit() {
  }

  addClicked(event: Event) {
    event.preventDefault();

    if (!this.disabled) {
      this.addClick.emit();
    }
  }
}
